import api from './api';

const inventarioInformes = {
    getStockPorDeposito: async (params: {
        codigoArticulo?: string;
        descripcion?: string;
        nroUbicacion?: number;
        page?: number;
        pageSize?: number;
    }) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.codigoArticulo) queryParams.append('codigoArticulo', params.codigoArticulo);
            if (params.descripcion) queryParams.append('descripcion', params.descripcion);
            if (params.nroUbicacion) queryParams.append('nroUbicacion', params.nroUbicacion.toString());
            if (params.page) queryParams.append('page', params.page.toString());
            if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString());

            const response = await api.get(`/api/InventarioInformes/stock-deposito?${queryParams.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error en getStockPorDeposito:', error);
            throw error;
        }
    },

    getStockPorDepositoPdf: async (filters: {
        codigoArticulo?: string;
        descripcion?: string;
        nroUbicacion?: number;
    }) => {
        const params = new URLSearchParams();
        if (filters.codigoArticulo) params.append('codigoArticulo', filters.codigoArticulo);
        if (filters.descripcion) params.append('descripcion', filters.descripcion);
        if (filters.nroUbicacion) params.append('nroUbicacion', filters.nroUbicacion.toString());

        const response = await api.get(`/api/InventarioInformes/stock-deposito/pdf?${params.toString()}`, {
            responseType: 'blob'
        });
        return response.data;
    },

    getUbicaciones: async () => {
        try {
            const response = await api.get('/api/InventarioInformes/ubicaciones');
            return response.data;
        } catch (error) {
            console.error('Error al obtener ubicaciones:', error);
            throw error;
        }
    },

    getMovimientosStock: async (params: {
        fechaDesde?: Date;
        fechaHasta?: Date;
        codigoArticulo?: string;
        tipoMovimiento?: string;
        deposito?: number;
        page?: number;
        pageSize?: number;
    }) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.fechaDesde) queryParams.append('fechaDesde', params.fechaDesde.toISOString());
            if (params.fechaHasta) queryParams.append('fechaHasta', params.fechaHasta.toISOString());
            if (params.codigoArticulo) queryParams.append('codigoArticulo', params.codigoArticulo);
            if (params.tipoMovimiento) queryParams.append('tipoMovimiento', params.tipoMovimiento);
            if (params.deposito) queryParams.append('deposito', params.deposito.toString());
            if (params.page) queryParams.append('page', params.page.toString());
            if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString());

            const response = await api.get(`/api/InventarioInformes/movimientos-stock?${queryParams.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error en getMovimientosStock:', error);
            throw error;
        }
    },

    getMovimientosStockPdf: async (filters: {
        fechaDesde?: Date;
        fechaHasta?: Date;
        codigoArticulo?: string;
        tipoMovimiento?: string;
        deposito?: number;
    }) => {
        const params = new URLSearchParams();
        if (filters.fechaDesde) params.append('fechaDesde', filters.fechaDesde.toISOString());
        if (filters.fechaHasta) params.append('fechaHasta', filters.fechaHasta.toISOString());
        if (filters.codigoArticulo) params.append('codigoArticulo', filters.codigoArticulo);
        if (filters.tipoMovimiento) params.append('tipoMovimiento', filters.tipoMovimiento);
        if (filters.deposito) params.append('deposito', filters.deposito.toString());

        const response = await api.get(`/api/InventarioInformes/movimientos-stock/pdf?${params.toString()}`, {
            responseType: 'blob'
        });
        return response.data;
    }
};

export default inventarioInformes;
